import { useCallback, useEffect, useState } from "react";
import { ChartAreaLoader } from "../../../components/Loading";
import NewFilterContainer from "../../../components/NewFilterContainer ";
import FilterMenu from "../../../components/FilterMenu";
import MainPageContainer from "../../../components/MainPageContainer";
import SecondaryHeader from "../Demand/SecondaryHeader";
import { SearchBox } from "../../../components/Search";
import { setLoadingFilterName } from "../../../store/state/FilterLoadingState";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { getRajOutageData } from "../Utility/RestApi";
import { formatDateForAPI } from "../const";
interface OutageData {
  generator_name: string;
  unit: string;
  reason_outage: string;
  outage_type: string;
  sector: string;
  from_date: string;
  to_date: string;
  from_time: string;
  to_time: string;
  outage_mw: string;
  outage_mwh?: string;
}

// Header Cell Component
const HeaderCell: React.FC<{ title: React.ReactNode }> = ({ title }) => (
  <th className="py-3 text-[14px] px-4 text-center font-medium text-[#F1935C] whitespace-nowrap">
    {title}
  </th>
);

const DEMAND_UNITS = ["mw", "mwh"];
const SECTOR = ["Central Sector", "State Sector", "Other"];
const OUTAGE_TYPE = ["Forced Outage", "Planned Outage", "Other"];

export default function RajOutage() {
  const dispatch = useDispatch();
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const [loading, setLoading] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(DEMAND_UNITS[0]);
  const [selectedSector, setSelectedSector] = useState<any[]>([]);
  const [selectedOutage, setSelectedOutage] = useState<any[]>([]);
  const [uniqueGenerator, setUniqueGenerator] = useState<string[]>([]);
  // const [uniqueGeneratorUnit, setUniqueGeneratorUnit] = useState<string[]>([]);
  const [selectedGenerator, setSelectedGenerator] = useState<any[]>([]);
  const [selectedGeneratorUnit, setSelectedGeneratorUnit] = useState<any[]>([]);
  const [Data, setData] = useState<OutageData[]>([]);
  const [filterData, setfilterData] = useState<OutageData[]>([]);
  const [sortBy, setSortBy] = useState<string>("generator_name");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const handleUnitChange = (params: string) => {
    setSelectedUnit(params);
  };

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;
    const startDateStr = formatDateForAPI(dates.startDate);
    const endDateStr = formatDateForAPI(dates.endDate);
    const response = await getRajOutageData(startDateStr, endDateStr);
    let transformerData = response.map((item: OutageData) => ({
      ...item,
      sector:
        item.sector === "NO SECTOR TYPE"
          ? "Other"
          : item.sector === "CENTRAL SECTOR"
          ? "Central Sector"
          : item.sector === "STATE SECTOR"
          ? "State Sector"
          : item.sector,
      outage_type:
        item.outage_type === "NO OUTAGE TYPE"
          ? "Other"
          : item.outage_type === "FORCE OUTAGE"
          ? "Forced Outage"
          : item.outage_type === "PLANNED OUTAGE"
          ? "Planned Outage"
          : item.outage_type,
      outage_mwh: Number(item.outage_mw) / 4,
    }));
    setData(transformerData);
    setLoading(false);
  }, [DefaultDates, activeTab]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  useEffect(() => {
    let filterData = Data;

    if (selectedSector.length > 0) {
      filterData = filterData.filter((item) =>
        selectedSector.includes(item.sector)
      );
    }

    if (selectedOutage.length > 0) {
      filterData = filterData.filter((item) =>
        selectedOutage.includes(item.outage_type)
      );
    }

    setUniqueGenerator(
      Array.from(new Set(filterData.map((item) => item.generator_name)))
    );
    // setUniqueGeneratorUnit(
    //   Array.from(new Set(filterData.map((item) => item.unit)))
    // );
    if (selectedGenerator.length > 0) {
      if (selectedGenerator) {
        // 🔁 Get all units from all selected generators
        const selectedLabels = selectedGenerator.map((g) => g.label);
        const filteredByGenerator = filterData.filter((item) =>
          selectedLabels.includes(item.generator_name)
        );
        const units = filteredByGenerator.map((item) => ({
          label: item.unit,
          value: item.unit,
        }));

        // Optional: remove duplicates
        const uniqueUnits = Array.from(
          new Map(units.map((u) => [u.value, u])).values()
        );

        setSelectedGeneratorUnit(uniqueUnits);
        filterData = filteredByGenerator;
      }
    } else {
      setSelectedGeneratorUnit([]);
    }
    setfilterData(filterData);
  }, [Data, selectedGenerator, selectedOutage, selectedSector]);

  function handleSort(field: string): void {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
    setfilterData((prevData) => {
      const sorted = [...prevData].sort((a, b) => {
        let aValue = (a as any)[field];
        let bValue = (b as any)[field];
        // Try to compare as numbers if possible
        if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
          aValue = Number(aValue);
          bValue = Number(bValue);
        }
        if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
      return sorted;
    });
  }
  const downloadTable = () => {
    const table = document.getElementById("my-table");
    const worksheet = XLSX.utils.table_to_sheet(table);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, "Outage_table.xlsx");
  };
  return (
    <>
      <div className="page-container outageTable">
        <div className="gas-page-container">
          <NewFilterContainer>
            <div className="side-filters-container text-nowrap">
              <FilterMenu
                title="Unit"
                items={DEMAND_UNITS}
                selectedItems={[selectedUnit]}
                onSelect={(item, index) => {
                  handleUnitChange(item);
                  dispatch(setLoadingFilterName(""));
                }}
              />
              <FilterMenu
                title="Sector"
                items={SECTOR}
                selectedItems={selectedSector}
                setSelectedItems={setSelectedSector}
                onSelect={() => {
                  dispatch(setLoadingFilterName(""));
                }}
              />
              <FilterMenu
                title="Type of Outage"
                items={OUTAGE_TYPE}
                selectedItems={selectedOutage}
                setSelectedItems={setSelectedOutage}
                onSelect={() => {
                  dispatch(setLoadingFilterName(""));
                }}
              />
            </div>
          </NewFilterContainer>

          <MainPageContainer>
            <SecondaryHeader showViewMode={false} />
            <div className="gas-chart-container">
              {loading ? <ChartAreaLoader title="Loading Outage Data" subtitle="Fetching planned & forced outage records…" /> : (<>
              <div className="gas-heading">
                <h2 className="chartHeading w-80">Outage Table</h2>
                <div className="flex gap-x-2 w-full justify-end">
                  {/* <SearchBox
                    options={uniqueGeneratorUnit.map((item) => ({
                      label: item,
                      value: item,
                    }))}
                    isMany={true}
                    placeholder="Generator Unit"
                    selectedOptions={selectedGeneratorUnit}
                    onChange={setSelectedGeneratorUnit}
                  /> */}
                  <SearchBox
                    options={uniqueGenerator.map((item) => ({
                      label: item,
                      value: item,
                    }))}
                    isMany={true}
                    placeholder="Search Generator"
                    selectedOptions={selectedGenerator}
                    onChange={setSelectedGenerator}
                  />
                  <button onClick={downloadTable} className="downloadButton">
                    Download Data
                  </button>
                </div>
              </div>
              <div
                className="overflow-auto capitalize text-nowrap"
                style={{ maxHeight: "calc(100vh - 300px)" }}
              >
                <table id="my-table">
                  <thead className="sticky top-0 z-10">
                    <tr className="text-sm">
                      {/* Basic Outage Details */}
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("generator_name")}
                          >
                            Generator
                            {sortBy === "generator_name" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("unit")}
                          >
                            Unit
                            {sortBy === "unit" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("from_date")}
                          >
                            From Date
                            {sortBy === "from_date" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("to_date")}
                          >
                            To Date
                            {sortBy === "to_date" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("from_time")}
                          >
                            From Time
                            {sortBy === "from_time" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("to_time")}
                          >
                            To Time
                            {sortBy === "to_time" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("outage_mw")}
                          >
                            Outage{" "}
                            <span className="text-[#34656D] ms-1 font-medium">
                              {selectedUnit === "mw" ? "(MW)" : "(MWh)"}
                            </span>
                            {sortBy === "outage_mw" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                      <HeaderCell
                        title={
                          <span
                            className="cursor-pointer select-none flex items-center justify-center gap-1"
                            onClick={() => handleSort("reason_outage")}
                          >
                            Reason Of Outage
                            {sortBy === "reason_outage" &&
                              (sortOrder === "asc" ? "▲" : "▼")}
                          </span>
                        }
                      />
                    </tr>
                  </thead>
                  <tbody className="text-[#8C8A96] font-normal text-[13px]">
                    {filterData.map((item, idx) => (
                      <tr
                        key={idx}
                        className="border-b border-gray-200 hover:bg-gray-100 text-center"
                      >
                        <td className="py-3 px-4 text-center whitespace-normal max-w-[200px]">
                          {item.generator_name}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {item.unit === "" ? "-" : item.unit}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {item.from_date === "" ? "-" : item.from_date}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {item.to_date === "" ? "-" : item.to_date}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {item.from_time === "" ? "-" : item.from_time}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {item.to_time === "" ? "-" : item.to_time}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {selectedUnit === "mw"
                            ? item.outage_mw
                            : item.outage_mwh}
                        </td>
                        <td className="py-3 px-4 text-center whitespace-normal max-w-[400px]">
                          {item.reason_outage === null
                            ? "-"
                            : item.reason_outage}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination controls - uncomment if needed */}
              {/* <div className="flex justify-between items-center mt-4">
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Previous
                </button>
                <div>
                  Page {currentPage} of {totalPages}
                </div>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Next
                </button>
              </div> */}
              </>)}
            </div>
            <div className="gna-footer-container">
              <div className="grid grid-cols-3 justify-between gap-5 ">
                <p className="gna-footer-text col-span-1 text-start">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <p></p>
                <strong className="gna-footer-text col-span-1 text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          </MainPageContainer>
        </div>
      </div>
    </>
  );
}
